import Link from 'next/link';
import React, {useState} from 'react';
import router from 'next/router';
import {useDispatch} from 'react-redux';
import {notifySignout} from '@components/common/toast';
import Image from 'next/image';
import {useDisconnect} from 'wagmi';
import {clearWalletConnectCache} from '@components/walletConnect';
import {useApp} from '@components/providers/app-provider';

const MblUserMenu = () => {
  const [profileShow, setProfileShow] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const {jwt: token, user, setJWT, setLanguage, language, setLoginShow} = useApp();
  const dispatch = useDispatch();
  const disconnectWalletConnect = useDisconnect();

  const signOut = () => {
    setJWT && setJWT(null);
    disconnectWalletConnect;
    clearWalletConnectCache();
    router.push('/');
  };
  const handleUserProfileClick = () => {
    setLoginShow && setLoginShow(true);
    setProfileShow(false);
  };

  return (
    <div>
      <button
        className=" border-jacarta-100 ml-2 flex h-10 w-10 items-center justify-center rounded-full border transition-colors hover:border-transparent focus:border-transparent dark:border-transparent dark:bg-white/[.15] z-30"
        onClick={() => {
          token ? setProfileShow(true) : handleUserProfileClick();
        }}
      >
        {token ? (
          <Image
            src={
              user?.profile_picture
                ? `${process.env.NEXT_PUBLIC_UPLOAD_URL}${user?.profile_picture}`
                : '/images/user/user_avatar_new.png'
            }
            alt={`${user?.first_name} ${user?.last_name}`}
            width={50}
            height={50}
            objectFit={'cover'}
            className="rounded-full "
            unoptimized
          ></Image>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
            className="fill-jacarta-700 h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:fill-white"
          >
            <path fill="none" d="M0 0h24v24H0z"></path>
            <path d="M11 14.062V20h2v-5.938c3.946.492 7 3.858 7 7.938H4a8.001 8.001 0 0 1 7-7.938zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6z"></path>
          </svg>
        )}
      </button>

      <div
        className={
          profileShow
            ? 'js-mobile-menu dark:bg-dark-navy visible fixed top-[80px] bottom-0 left-0 right-0  z-10 ml-auto items-center bg-white opacity-0 lg:visible lg:relative lg:inset-auto lg:flex lg:bg-transparent lg:opacity-100 dark:lg:bg-transparent nav-menu--is-open h-fit'
            : 'js-mobile-menu dark:bg-dark-navy invisible fixed top-[80px] bottom-0 left-0 right-0  z-10 ml-auto items-center bg-white opacity-0 lg:visible lg:relative lg:inset-auto lg:flex lg:bg-transparent lg:opacity-100 dark:lg:bg-transparent '
        }
        // onClick={() => {
        //   setProfileShow(true);
        // }}
      >
        <div
          className={` ${isActive ? ' visible' : 'invisible'}  dark:bg-dark-navy
              h-full w-full
               !top-[0px] left-0 right-0  z-40
               whitespace-nowrap
              rounded-xl bg-white absolute
              before:-top-1 
               lg:py-4 lg:px-2
              shadow-2xl text-sm `}
        >
          <a className="fixed pl-4 py-3 " onClick={() => setIsActive(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="m10.875 19.3l-6.6-6.6q-.15-.15-.213-.325Q4 12.2 4 12t.062-.375q.063-.175.213-.325l6.6-6.6q.275-.275.687-.288q.413-.012.713.288q.3.275.313.687q.012.413-.288.713L7.4 11h11.175q.425 0 .713.287q.287.288.287.713t-.287.712Q19 13 18.575 13H7.4l4.9 4.9q.275.275.288.7q.012.425-.288.7q-.275.3-.7.3q-.425 0-.725-.3Z"
              />
            </svg>
          </a>
          <div className="mt-10">
            <a
              onClick={() => {
                setIsActive(false);
                setLanguage && setLanguage('en');
              }}
              className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors cursor-pointer "
            >
              {language == 'en' ? (
                <div>
                  <span className="font-display dark:text-white text-jacarta-700 mt-1 ">
                    English
                  </span>
                  <span className="fixed left-20">
                    <Image width={16} height={16} src={'/check.png'} alt="check"></Image>
                  </span>
                </div>
              ) : (
                <span className="font-display dark:text-white text-jacarta-700 mt-1 ">English</span>
              )}
            </a>
            <a
              onClick={() => {
                setIsActive(false);
                setLanguage && setLanguage('id');
              }}
              className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors cursor-pointer"
            >
              {language == 'id' ? (
                <div>
                  <span className="font-display dark:text-white text-jacarta-700 mt-1 ">
                    Bahasa
                  </span>
                  <span className="fixed left-20">
                    <Image width={16} height={16} src={'/check.png'} alt="check"></Image>
                  </span>
                </div>
              ) : (
                <span className="font-display dark:text-white text-jacarta-700 mt-1 ">Bahasa</span>
              )}
            </a>
          </div>
        </div>
        <div className="absolute top-0 right-0 py-4">
          <button type="button" className="btn-close" onClick={() => setProfileShow(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 26 26"
              width="20"
              height="20"
              className="fill-jacarta-700 h-6 w-6 dark:fill-white"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
            </svg>
          </button>
        </div>
        <div className="pt-8 pl-0">
          <Link href={`/user/${user ? user.wallet_address : ''}`}>
            <a
              onClick={() => setProfileShow(false)}
              className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl  py-4 transition-colors"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
              >
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="M11 14.062V20h2v-5.938c3.946.492 7 3.858 7 7.938H4a8.001 8.001 0 0 1 7-7.938zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6z"></path>
              </svg>
              <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                My Profile
              </span>
            </a>
          </Link>
          <Link href={`/user/${user ? user.wallet_address : ''}?activeTab=3#user-items`}>
            <a
              onClick={() => setProfileShow(false)}
              className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl  py-4 transition-colors"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
              >
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="M12.07937 13.5904C8.4716 14.1378 7.53596 14.1378 6.92819 13.5825L6.84023 13.5032C2.64184 9.7348 -0.101104 7.26751 0.00285575 4.18935C0.0508373 2.84068 0.74657 1.54753 1.87414 0.785926C3.98532 -0.642086 6.59232 0.0243193 7.99978 1.6586C9.40724 0.0243193 12.0142 -0.65002 14.1254 0.785926C15.253 1.54753 15.9487 2.84068 15.9967 4.18935C16.1087 7.26751 13.3577 9.7348 9.15934 13.519L9.07937 13.5904Z" />{' '}
              </svg>
              <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                Favorites
              </span>
            </a>
          </Link>
          <Link href="/watchlist">
            <a className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl  py-4 transition-colors">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
              >
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="M10.3979 4.99895C10.3979 6.32491 9.32239 7.39981 7.99565 7.39981C6.66893 7.39981 5.59341 6.32491 5.59341 4.99895C5.59341 3.67298 6.66893 2.59809 7.99565 2.59809C9.32239 2.59808 10.3979 3.67299 10.3979 4.99895ZM8 0C6.62633 0.00635641 5.20248 0.355208 3.85461 1.0231C2.85384 1.53943 1.87853 2.2679 1.03192 3.16705C0.616107 3.62603 0.0857467 4.29063 0 4.99973C0.0101333 5.61396 0.641733 6.37212 1.03192 6.83242C1.82583 7.69625 2.77573 8.40439 3.85461 8.9769C5.11156 9.61325 6.50283 9.97962 8 10C9.37497 9.99355 10.7985 9.64067 12.1449 8.9769C13.1457 8.46057 14.1215 7.73157 14.9681 6.83242C15.3839 6.37344 15.9142 5.70882 16 4.99973C15.9899 4.38549 15.3583 3.62731 14.9681 3.16702C14.1742 2.30319 13.2238 1.5956 12.1449 1.02308C10.8886 0.387213 9.49389 0.0233532 8 0ZM7.99899 1.24135C10.0806 1.24135 11.768 2.92426 11.768 5.00027C11.768 7.07627 10.0806 8.75918 7.99899 8.75918C5.9174 8.75918 4.22999 7.07626 4.22999 5.00027C4.22999 2.92426 5.9174 1.24135 7.99899 1.24135Z" />{' '}
              </svg>
              <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                Watchlist
              </span>
            </a>
          </Link>
          <Link href="/collection/my-collection">
            <a
              onClick={() => setProfileShow(false)}
              className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl py-4 transition-colors"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
              >
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="M13.4991 5.00118C14.1336 5.00106 14.7444 5.24225 15.2077 5.67584C15.671 6.10943 15.9521 6.70298 15.994 7.33614L16 7.50014V13.5C16.0001 14.1347 15.7588 14.7457 15.325 15.2091C14.8912 15.6724 14.2974 15.9534 13.6641 15.995L13.5001 16H7.50024C6.86554 16.0001 6.25456 15.7588 5.79124 15.325C5.32792 14.8912 5.04694 14.2974 5.00531 13.664L5.00031 13.5V7.50014C5.00021 6.86543 5.24153 6.25445 5.67533 5.79112C6.10912 5.32779 6.70291 5.04682 7.33624 5.00518L7.49924 5.00118H13.4991ZM10.5002 7.00115C10.3831 7.00111 10.2698 7.04212 10.1799 7.11703C10.09 7.19195 10.0292 7.29603 10.0082 7.41114L10.0002 7.50114V10.0011H7.49924L7.40924 10.0081C7.29396 10.029 7.18967 10.0897 7.11457 10.1796C7.03947 10.2695 6.99834 10.3829 6.99834 10.5001C6.99834 10.6172 7.03947 10.7307 7.11457 10.8206C7.18967 10.9105 7.29396 10.9712 7.40924 10.9921L7.49924 11.0001H9.99917V13.5L10.0072 13.59C10.028 13.7053 10.0887 13.8096 10.1786 13.8847C10.2686 13.9598 10.382 14.0009 10.4992 14.0009C10.6163 14.0009 10.7297 13.9598 10.8197 13.8847C10.9096 13.8096 10.9703 13.7053 10.9911 13.59L10.9991 13.501V11.0011H13.4991L13.5891 10.9931C13.7043 10.9722 13.8086 10.9115 13.8837 10.8216C13.9588 10.7317 14 10.6182 14 10.5011C14 10.3839 13.9588 10.2705 13.8837 10.1806C13.8086 10.0907 13.7043 10.03 13.5891 10.0091L13.4991 10.0011H10.9991V7.50114L10.9911 7.41114C10.9701 7.29603 10.9093 7.19195 10.8194 7.11703C10.7295 7.04212 10.6162 7.00111 10.4992 7.00115H10.5002ZM10.6621 1.69523L10.7101 1.85323L11.2851 4.00019H7.00025C6.23506 4.00015 5.49878 4.29251 4.94205 4.81746C4.38532 5.34241 4.05023 6.06027 4.00533 6.82415L4.00033 7.00015V12.3481C3.48953 12.337 2.99436 12.1697 2.58141 11.8689C2.16846 11.568 1.85752 11.1479 1.6904 10.6651L1.6384 10.4951L0.0854429 4.70018C-0.0790753 4.08715 -0.00425691 3.4345 0.294721 2.8746C0.5937 2.31471 1.09445 1.8895 1.6954 1.68523L1.85339 1.63823L7.64823 0.0852586C8.23409 -0.0717936 8.85707 -0.0104899 9.40108 0.257747C9.94509 0.525984 10.373 0.982857 10.6052 1.54323L10.6621 1.69523V1.69523Z" />
              </svg>
              <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                My Collection
              </span>
            </a>
          </Link>
          <Link href="/user/edit">
            <a
              onClick={() => setProfileShow(false)}
              className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl  py-4 transition-colors"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                className="fill-dark-navy h-4 w-4 transition-colors group-hover:fill-white group-focus:fill-white dark:fill-white"
              >
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="M9.954 2.21a9.99 9.99 0 0 1 4.091-.002A3.993 3.993 0 0 0 16 5.07a3.993 3.993 0 0 0 3.457.261A9.99 9.99 0 0 1 21.5 8.876 3.993 3.993 0 0 0 20 12c0 1.264.586 2.391 1.502 3.124a10.043 10.043 0 0 1-2.046 3.543 3.993 3.993 0 0 0-3.456.261 3.993 3.993 0 0 0-1.954 2.86 9.99 9.99 0 0 1-4.091.004A3.993 3.993 0 0 0 8 18.927a3.993 3.993 0 0 0-3.457-.26A9.99 9.99 0 0 1 2.5 15.121 3.993 3.993 0 0 0 4 11.999a3.993 3.993 0 0 0-1.502-3.124 10.043 10.043 0 0 1 2.046-3.543A3.993 3.993 0 0 0 8 5.071a3.993 3.993 0 0 0 1.954-2.86zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"></path>
              </svg>
              <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                Edit Profile
              </span>
            </a>
          </Link>
          <a
            onClick={() => {
              setIsActive(!isActive);
            }}
            className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl  py-4 transition-colors"
          >
            <div className="flex space-x-2 items-center cursor-pointer ">
              <svg
                width="24"
                height="24"
                fill="white"
                xmlns="http://www.w3.org/2000/svg"
                className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
              >
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="M7.9925 0.5C3.8525 0.5 0.5 3.86 0.5 8C0.5 12.14 3.8525 15.5 7.9925 15.5C12.14 15.5 15.5 12.14 15.5 8C15.5 3.86 12.14 0.5 7.9925 0.5ZM13.19 5H10.9775C10.7428 4.07109 10.3952 3.17442 9.9425 2.33C11.3106 2.801 12.4634 3.74879 13.19 5ZM8 2.03C8.6225 2.93 9.11 3.9275 9.4325 5H6.5675C6.89 3.9275 7.3775 2.93 8 2.03ZM2.195 9.5C2.075 9.02 2 8.5175 2 8C2 7.4825 2.075 6.98 2.195 6.5H4.73C4.67 6.995 4.625 7.49 4.625 8C4.625 8.51 4.67 9.005 4.73 9.5H2.195ZM2.81 11H5.0225C5.2625 11.9375 5.6075 12.8375 6.0575 13.67C4.68798 13.2016 3.53437 12.2531 2.81 11V11ZM5.0225 5H2.81C3.53437 3.74688 4.68798 2.79843 6.0575 2.33C5.60482 3.17442 5.25723 4.07109 5.0225 5V5ZM8 13.97C7.3775 13.07 6.89 12.0725 6.5675 11H9.4325C9.11 12.0725 8.6225 13.07 8 13.97ZM9.755 9.5H6.245C6.1775 9.005 6.125 8.51 6.125 8C6.125 7.49 6.1775 6.9875 6.245 6.5H9.755C9.8225 6.9875 9.875 7.49 9.875 8C9.875 8.51 9.8225 9.005 9.755 9.5ZM9.9425 13.67C10.3925 12.8375 10.7375 11.9375 10.9775 11H13.19C12.4634 12.2512 11.3106 13.199 9.9425 13.67V13.67ZM11.27 9.5C11.33 9.005 11.375 8.51 11.375 8C11.375 7.49 11.33 6.995 11.27 6.5H13.805C13.925 6.98 14 7.4825 14 8C14 8.5175 13.925 9.02 13.805 9.5H11.27Z" />{' '}
              </svg>
              <div className="flex justify-between">
                <div>
                  <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                    Language
                  </span>
                </div>
                <div className="fixed right-8">
                  {language == 'en' ? (
                    <span className="text-sm">EN &gt;</span>
                  ) : (
                    <span className="text-sm">ID &gt;</span>
                  )}
                </div>
              </div>
            </div>
          </a>

          <button>
            <a
              onClick={() => {
                signOut(), setProfileShow(false), notifySignout();
              }}
              className="dark:hover:bg-jacarta-600 hover:text-accent focus:text-accent hover:bg-jacarta-50 flex items-center space-x-2 rounded-xl  py-4 transition-colors"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                className="fill-jacarta-700 h-4 w-4 transition-colors dark:fill-white"
              >
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="M9.00147 1.45852V7.2992H15.7004L14.1503 5.78502C14.0357 5.67343 13.9661 5.52539 13.954 5.36788C13.942 5.21037 13.9883 5.05388 14.0846 4.92692L14.1503 4.85314C14.2647 4.74171 14.4163 4.67405 14.5776 4.66244C14.7388 4.65084 14.8989 4.69607 15.0289 4.7899L15.1045 4.85314L17.8022 7.48628C17.9165 7.59781 17.9861 7.74568 17.9981 7.90299C18.0102 8.0603 17.964 8.21661 17.8679 8.3435L17.8022 8.41728L15.1054 11.0548C14.9849 11.1719 14.8236 11.2403 14.6537 11.2463C14.4838 11.2524 14.3178 11.1957 14.1888 11.0875C14.0599 10.9794 13.9776 10.8278 13.9582 10.6629C13.9389 10.4981 13.984 10.3322 14.0846 10.1985L14.1494 10.1247L15.6914 8.61665H9.00237L9.00147 14.5416C9.00139 14.6378 8.97974 14.7327 8.93806 14.8198C8.89637 14.9069 8.83566 14.984 8.76017 15.0458C8.68469 15.1076 8.59627 15.1525 8.50111 15.1774C8.40595 15.2022 8.30636 15.2065 8.20934 15.1898L0.558091 13.8715C0.401683 13.8446 0.259986 13.7648 0.157913 13.6461C0.05584 13.5274 -7.45824e-05 13.3774 7.46646e-08 13.2224V2.68462C2.38112e-06 2.5285 0.0568388 2.37744 0.160374 2.25841C0.263909 2.13937 0.407412 2.06008 0.565292 2.03468L8.21654 0.808578C8.31319 0.793032 8.41214 0.798191 8.50653 0.823696C8.60093 0.849202 8.6885 0.894443 8.76318 0.95628C8.83786 1.01812 8.89786 1.09507 8.93901 1.1818C8.98016 1.26852 9.00147 1.36295 9.00147 1.45852ZM5.85276 7.73396C5.61343 7.73396 5.3839 7.82673 5.21467 7.99185C5.04543 8.15698 4.95036 8.38093 4.95036 8.61445C4.95036 8.84798 5.04543 9.07193 5.21467 9.23706C5.3839 9.40218 5.61343 9.49495 5.85276 9.49495C6.09209 9.49495 6.32162 9.40218 6.49085 9.23706C6.66008 9.07193 6.75515 8.84798 6.75515 8.61445C6.75515 8.38093 6.66008 8.15698 6.49085 7.99185C6.32162 7.82673 6.09209 7.73396 5.85276 7.73396ZM9.90162 13.8847H10.5902L10.682 13.8785C10.8438 13.8569 10.9921 13.7787 11.0993 13.6586C11.2066 13.5384 11.2656 13.3844 11.2653 13.2251L11.259 9.49231H9.90162V13.8838V13.8847ZM9.90342 6.41739L9.90162 5.29756V2.0259H10.5722C10.7352 2.02588 10.8927 2.0834 11.0157 2.18785C11.1386 2.2923 11.2187 2.43662 11.241 2.59416L11.2473 2.68287L11.2536 6.41739H9.90342V6.41739Z" />{' '}
              </svg>
              <span className="font-display dark:text-white text-jacarta-700 mt-1 text-sm">
                Sign out
              </span>
            </a>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MblUserMenu;
